import { Component, Inject, OnInit } from "@angular/core";
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
} from "@angular/material/dialog";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { SnackBarService } from "cw-utils";
import { ReportProvider } from "../../../../../../../../../shared/cw-backend/providers/application/report/report.provider";

@Component({
    selector: "app-print-os",
    templateUrl: "./print-os.component.html",
    styleUrls: ["./print-os.component.scss"],
})
export class PrintOsComponent implements OnInit {
    public ngxExtendedPdfViewerConfig: any = {
        printResolution: 600,
    };

    pdf: any;
    sendingEmail: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<PrintOsComponent>,
        private reportprovider: ReportProvider,
        private snackBar: SnackBarService,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit(): void {
        console.log("Imprindo...");
        this.pdf = null;
        this.pdf = this.data.pdf;
    }

    dimiss() {
        this.dialogRef.close();
    }

    sendEMail() {
        if (this.sendingEmail) {
            return;
        }

        const confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false,
        });

        let message = "Deseja enviar essa receita para o e-mail do paciente?";

        confirmDialogRef.componentInstance.action = "delete";
        confirmDialogRef.componentInstance.deleteMessage = message;

        confirmDialogRef.afterClosed().subscribe(async (result) => {
            if (!result) {
                return;
            }

            try {
                this.sendingEmail = true;
                this.reportprovider
                    .sendEmailPdfReceiptOS(this.data.id, this.data.type)
                    .then((x) => {
                        this.snackBar.successMessage(
                            "E-mail enviado com sucesso!",
                        );
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        this.sendingEmail = false;
                    });
            } catch (err) {
                console.error("Erro ao enviar e-mail com PDF", err);
            } finally {
                this.sendingEmail = false;
            }
        });
    }
}
